/* eslint-disable indent */
((window, document) => {
  function loopPills() {
    const tileList = document.querySelectorAll('.js-pill-tile');
    tileList.forEach((tile) => {
      const pills = tile.querySelectorAll('.pill');
      const visiblePill = tile.querySelector('.pill--visible');
      if (visiblePill) {
        const randomDelay = Math.random() * 2000 + 1000;
        setTimeout(() => {
          visiblePill.classList.remove('pill--visible');
          const nextPill = visiblePill.nextElementSibling || pills[0];
          nextPill.classList.add('pill--visible');
        }, randomDelay);
      }
    });
  }

  function initialisePills() {
    const tileList = document.querySelectorAll('.js-pill-tile');
    tileList.forEach((tile) => {
      const pills = tile.getAttribute('data-pills');
      const pillsArray = pills
        ? pills
            .split(',')
            .map((pill) => pill.trim())
            .filter((pill) => pill.startsWith('pill^'))
        : [];
      if (pillsArray) {
        const pillContainer = document.createElement('span');
        pillContainer.classList.add('pill-container');
        pillsArray.forEach((singlePill, index) => {
          const [type, pillText, backgroundColour, textColour, iconName, overrideText] =
            singlePill.split('^');
          const displayText = overrideText && overrideText !== 'null' ? overrideText : pillText;

          if (type === 'pill') {
            const pill = document.createElement('span');
            pill.classList.add('pill');
            if (index === 0) {
              pill.classList.add('pill--visible');
            }
            pill.innerText = displayText;
            if (backgroundColour && backgroundColour !== 'null') {
              pill.style.backgroundColor = `#${backgroundColour}`;
            }
            if (textColour && textColour !== 'null') {
              pill.style.color = `#${textColour}`;
            }

            if (iconName) {
              const SVG_NS = 'http://www.w3.org/2000/svg';
              const icon = document.createElementNS(SVG_NS, 'svg');
              icon.classList.add('icon');
              icon.style.color = `#${textColour}`;
              const use = document.createElementNS(SVG_NS, 'use');
              use.setAttribute('href', `#${iconName}`);
              icon.appendChild(use);
              pill.prepend(icon);
            }
            pillContainer.appendChild(pill);

            // -- Temp code to add box shadow for Spring Prize Giveaway pill --
            if (
              pillText === 'Spring Prize Giveaway' &&
              !tile.classList.contains('vdp-grid--item-1')
            ) {
              tile.style.boxShadow = '0 0 15px -5px #1896D2';
            }
            // -- ---------------------------------------------------------- --
          }
        });
        tile.appendChild(pillContainer);
      }
    });
    setInterval(loopPills, 5000);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initialisePills();
  });
})(window, document);
